module.exports = __webpack_public_path__ + "static/david-lamp-zoom-93a3dd254f41e1223bca8de3804975a7.jpg";